import React, { useState } from "react";
import axios from "axios";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from '@chakra-ui/react';
import { TokenManager } from "utils/tokenManager";

const ResetAPISecretConfirmModal: React.FC<{
    details: any;
    mode: "merchant" | "subaccount";
    isOpen: boolean;
    onClose(): void;
    setSwalProps: any;
    showResetAPISecretSuccessModal: any;
    setResetAPISecretInfo: any;
    activationStatus: any;
    apiKey: any;
}> = ({ isOpen, onClose, details, mode, setSwalProps, showResetAPISecretSuccessModal, setResetAPISecretInfo, activationStatus, apiKey }) => {

    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const userRole = localStorage.getItem("userRole")?.toLowerCase();

    const closeModal = async () => {
        onClose();
    };

    const handleSubmit = async () => {
        setIsProcessing(true);
        try {
            const postData = {
                ...(mode === "merchant"
                    ? { id: details.id, merchant_name: details.name }
                    : { subaccount_id: details.id, subaccount_name: details.suba_name }),
                is_active: activationStatus,
                auth1: apiKey,
                username: localStorage.getItem("username"),
                userRole: localStorage.getItem("userRole"),
                subaccountIdToVerify: localStorage.getItem("subaccountId")
            };

            await axios.post(
                process.env.REACT_APP_API_URL + `/api/${localStorage.getItem("userRole").toLowerCase()}/subaccount/action/reset-api-secret`,
                postData
            ).then(function (response) {
                if (response && response.data?.status === 'ok') {
                    setIsProcessing(false);
                    closeModal();
                    setResetAPISecretInfo(response.data.info);
                    showResetAPISecretSuccessModal(true);
                } else {
                    closeModal();
                    setIsProcessing(false);
                    setSwalProps({
                        show: true,
                        icon: "error",
                        title: "Oops!",
                        html: response.data.message,
                        showConfirmButton: true,
                        didClose: () => {
                            setSwalProps({});
                        },
                    });
                }
            }).catch(function (error) {
                closeModal();
                setIsProcessing(false);
                setSwalProps({
                    show: true,
                    icon: "error",
                    title: "Oops!",
                    html: error.response.data.message,
                    showConfirmButton: true,
                    didClose: () => {
                        setSwalProps({});
                    },
                });
            });
        } catch (error) {
            closeModal();
            console.error("Error reset api secret", error);
            setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: "Something went wrong, please try again later.",
                showConfirmButton: true,
                didClose: () => {
                    setSwalProps({});
                },
            });
            return false;
        }
    };

    return (
        <>
            {details &&
                <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                    <ModalOverlay className="bg-[#000] !opacity-30" />
                    <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] md:top-[12vh]">
                        <ModalBody className="!text-navy-700">
                            <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[650px] flex flex-col !z-[1004]">
                                <h1 className="mb-[20px] text-2xl font-bold">Reset the API Secret Confirmation</h1>
                                <div className="mb-[20px text-sm">
                                    <div className="mb-8">
                                        <p className="mb-3">
                                            You're about to reset the API Secret{userRole === "superadmin" ? ` for the current ${mode === "merchant" ? "merchant" : "subaccount"}.` : mode === "merchant" ? " for the merchant." : " for the subaccount."}
                                        </p>
                                        <p className="mb-3">
                                            Once reset, the existing API key will be permanently deactivated and can no longer be used to access the system. A new key will be generated and displayed only once, be sure to copy and store it securely.
                                        </p>
                                        <p className="mb-3">
                                            This action may affect any systems or integrations currently using the old key, so ensure you update your configuration accordingly.
                                        </p>
                                    </div>
                                </div>
                                <div className="flex gap-2 justify-end">
                                    <Button
                                        onClick={() => closeModal()}
                                        isDisabled={isProcessing}
                                        className="btn btn-default"
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        onClick={() => handleSubmit()}
                                        isDisabled={TokenManager.isImpersonating()}
                                        isLoading={isProcessing}
                                        loadingText='Processing...'
                                        className="btn text-white bg-red-600">
                                        Reset API Secret
                                    </Button>
                                </div>
                            </Card>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            }
        </>
    );
};

export default ResetAPISecretConfirmModal;
